export class PasswordChangeDTO {
  username: string;
  currentPassword: string;
  newPassword1: string;
  newPassword2: string;

  constructor(
    object: {
      username?: string;
      currentPassword?: string;
      newPassword1?: string;
      newPassword2?: string;
    } = {}
  ) {
    this.username = object.username;
    this.currentPassword = object.currentPassword;
    this.newPassword1 = object.newPassword1;
    this.newPassword2 = object.newPassword2;
  }
}
